<template>
  <div>
    <!-- <load-profile /> -->
    <div class="filter-container">
      <b-form-group
        :label="$t('general.search')"
        label-for="search"
        :class="{ 'has-value': params.search }"
      >
        <b-form-input
          v-model="params.search"
          name="search"
          :placeholder="$t('general.search')"
          clearable
          debounce="500"
          allow-clear
          @change="onChange"
          @keyup.enter.native="search"
        />
      </b-form-group>

      <b-form-group
        :label="$t('breadcrumb.serviceType')"
        label-for="serviceType"
        :class="{ 'has-value': params.serviceType }"
      >
        <n-async-single-select
          v-model="params.serviceType"
          name="serviceType"
          repository="serviceType"
          selection-key="code"
          selection-label="translations"
          clearable
          always-fresh
          :query="{
            isAdmin: isSuperAdmin,
            serviceCategoryCode:
              mainTabs.length === 3 ? null : query.serviceCategory,
            isChecked: true
          }"
          group-key="service"
          :must-excluded-ids="[]"
          :placeholder="$t('general.choose_service_type')"
          @change="onChange"
        />
      </b-form-group>

      <b-form-group
        :label="$t('breadcrumb.serviceSubType')"
        label-for="serviceSubType"
        :class="{ 'has-value': params.serviceSubType }"
      >
        <n-async-single-select
          :key="params.serviceType"
          v-model="params.serviceSubType"
          name="serviceSubType"
          repository="serviceSubType"
          selection-key="code"
          selection-label="translations"
          clearable
          always-fresh
          :query="{
            isAdmin: isSuperAdmin,
            serviceCategoryCode:
              mainTabs.length === 3 ? null : params.serviceCategory,
            isChecked: true,
            serviceTypeCodes: params.serviceType
          }"
          group-key="type"
          :must-excluded-ids="[]"
          :placeholder="$t('general.choose_service_sub_type')"
          @change="onChange"
        />
      </b-form-group>

      <div class="btn-container">
        <b-button
          variant="primary"
          :loading="loading"
          block
          class="btn-search"
          @click="search"
        >
          {{ $t('button.query') }}
        </b-button>
        <b-button
          variant="secondary"
          :loading="loading"
          block
          class="btn-reset"
          @click="reset"
        >
          {{ $t('button.reset') }}
        </b-button>
        <b-button
          variant="primary"
          :loading="loading"
          block
          class="btn-export"
          @click="exportExcel"
        >
          {{ $t('button.export_excel') }}
        </b-button>
      </div>

      <b-form-group
        :label="$t('general.date_range')"
        label-for="dateRange"
        :class="{ 'has-value': params.startDate || params.endDate }"
      >
        <div
          class="datetime-picker"
          style="width: 100%"
        >
          <n-date-picker
            v-model="params.startDate"
            :class="{
              'has-value': params.startDate,
              'custom-date-picker': true
            }"
            :style="{
              '--input-border-color': params.startDate
                ? 'var(--primary)'
                : '#ccc'
            }"
            style="width: 100%"
            name="startDate"
            clearable
            format="DD MMM YYYY"
            :placeholder="$t('general.from_date')"
          />
          <n-date-picker
            v-model="params.endDate"
            :class="{ 'has-value': params.endDate, 'custom-date-picker': true }"
            :style="{
              '--input-border-color': params.endDate ? 'var(--primary)' : '#ccc'
            }"
            style="width: 100%"
            name="endDate"
            clearable
            format="DD MMM YYYY"
            :placeholder="$t('general.to_date')"
          />
        </div>
      </b-form-group>

      <b-form-group
        :label="$t('general.origin')"
        label-for="origin"
        :class="{ 'has-value': params.origin }"
      >
        <n-single-select
          v-model="params.origin"
          name="origin"
          repository="serviceType"
          selection-key="value"
          selection-label="text"
          clearable
          :reduce="true"
          :options="[
            {
              value: 'manual',
              text: $t('general.manual')
            },
            // {
            //   value: 'external',
            //   text: $t('general.external')
            // },
            {
              value: 'chatagent',
              text: $t('general.chatagent')
            },
            {
              value: 'telegram',
              text: $t('general.telegram')
            },
            {
              value: 'application',
              text: $t('general.application')
            }
          ]"
          :placeholder="$t('general.choose_origin')"
          @change="onChange"
        />
      </b-form-group>

      <b-form-group
        :label="$t('field.operator')"
        label-for="operator"
        :class="{ 'has-value': params.operator }"
      >
        <n-async-single-select
          v-model="params.operator"
          name="operator"
          repository="allOperator"
          selection-key="id"
          selection-label="name"
          clearable
          always-fresh
          :must-excluded-ids="[]"
          :placeholder="$t('general.choose_operator')"
          @change="onChange"
        />
      </b-form-group>

      <div />

      <transition name="expand">
        <b-form-group
          v-if="!isCollapsed"
          :label="$t('field.department')"
          label-for="department"
          :class="{ 'has-value': params.departmentId }"
        >
          <n-async-single-select
            v-model="params.departmentId"
            name="department"
            repository="department"
            selection-key="id"
            selection-label="translations"
            clearable
            always-fresh
            :query="{ isAdmin: isSuperAdmin }"
            :must-excluded-ids="[]"
            :placeholder="$t('general.choose_department')"
            @change="onChange"
          />
        </b-form-group>
      </transition>
      <transition name="expand">
        <b-form-group
          v-if="!isCollapsed"
          :label="$t('breadcrumb.project')"
          label-for="project"
          :class="{ 'has-value': params.projectId }"
        >
          <n-async-single-select
            v-model="params.projectId"
            name="projectId"
            repository="project"
            selection-key="id"
            selection-label="translations"
            clearable
            :query="{ isAdmin: isSuperAdmin, isChecked: true }"
            always-fresh
            :placeholder="$t('general.choose_project')"
            @change="onChange"
          />
        </b-form-group>
      </transition>
    </div>

    <div class="icon-collapse">
      <feather-icon
        :icon="isCollapsed ? 'ChevronDownIcon' : 'ChevronUpIcon'"
        size="22"
        @click="toggleCollapse"
      />
    </div>
    <!-- {{ appStore.serviceBadgeCount }} -->
    <div class="switch-container">
      <div
        v-if="!loadingTabs"
        class="switch-background"
        :class="{ hidden: !mainTabs.length }"
        :data-tabs="mainTabs.length || 0"
      >
        <div
          v-if="mainTabs.length"
          class="switch-indicator"
          :style="{ left: indicatorPosition, width: indicatorWidth }"
        />
        <button
          v-for="(tab, index) in mainTabs"
          :key="tab.value + '-' + index"
          class="switch-button"
          :class="{
            active: (activeTab || '') === tab.value,
            'switch-button--placeholder': !mainTabs.length,
            'disabled-btn': loading
          }"
          @click="setActiveTab(tab.value, index)"
        >
          {{ tab.text }}
          <div
            v-if="getServiceCategoryBadgeCount(tab.value) > 0"
            class="badge badge-danger badge-pill"
          >
            {{ getServiceCategoryBadgeCount(tab.value) }}
          </div>
        </button>
      </div>
      <div
        v-else
        class="switch-background switch-background--loading"
        :class="{ hidden: !mainTabs.length }"
        data-tabs="1"
      >
        <div class="switch-button switch-button--loading" />
      </div>
      <div>
        <ServiceSystemFormService
          is-button
          :visitor-meta-data="{}"
        />
      </div>
    </div>
    <div
      no-body
      class="mb-0 b-card"
    >
      <div class="action-container">
        <div class="tab-list">
          <div
            v-for="tab in tabs"
            :key="tab.value"
            :class="{
              selected: tab.value === (query.status || ''),
              'disabled-btn': loading
            }"
            style="display: flex; align-items: center; gap: 0.1rem"
            @click="onTabClick(tab.value)"
          >
            {{ $t(tab.text) }}
            <div
              v-if="
                badgeCount[tab.value || 'all'] &&
                  ([
                    'pending',
                    'pendingPrice',
                    'pendingDispatch',
                    'accepted',
                    'processing',
                    'cancel'
                  ].includes(tab.value) ||
                    !tab.value)
              "
              class="badge-indicator"
            >
              {{
                badgeCount[tab.value || 'all'] > 99
                  ? '90+'
                  : badgeCount[tab.value || 'all']
              }}
            </div>
          </div>
        </div>

        <!-- <div
          class="btn-handover"
          @click="$emit('handover')"
        >
          <feather-icon
            icon="CornerDownRightIcon"
            size="17"
            class="align-middle text-body text-primary"
          />
          {{ $t('status.handover') }}
        </div> -->
      </div>

      <div>
        <n-table
          class="custom-service-table"
          :fields="fields"
          :items="channels"
          :busy="loading"
          :current-page="params.page"
          :per-page="10"
          :total="total"
          :type="permissionType"
          :previewable="false"
          @sort-changed="sortChanged"
        >
          <template #cell(serviceSubType)="data">
            <div
              v-if="(getSubType(data.item) || []).length > 0"
              style="display: flex; gap: 4px;"
            >
              {{ getSubType(data.item).join(', ') }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(orderId)="data">
            <div
              style="
                display: flex;
                justify-content: center;
                gap: 8px;
                align-items: center;
              "
            >
              <span>{{ getOrderId(data.item) }}</span>
              <b-button
                v-if="getOrderId(data.item) !== '-'"
                v-b-tooltip.hover
                :title="$t('button.copy_order_id')"
                variant="light"
                pill
                style="
                  height: fit-content;
                  width: fit-content;
                  padding: 4px 8px;
                  margin-right: 0.5rem;
                "
                size="sm"
                @click="
                  copyToClipboard(
                    (data.item.finalResultParams &&
                      data.item.finalResultParams.orderId) || data.item.id
                  )
                "
              >
                <feather-icon icon="CopyIcon" />
              </b-button>
            </div>
          </template>
          <template #cell(shortenName)="data">
            {{ getServiceName(data.item.name || data.shortenName) }}
          </template>
          <template #cell(projectName)="data">
            {{ getProjectName(data.item.projectName) }}
          </template>
          <template #cell(departmentName)="data">
            {{ data.item.departmentName || '-' }}
          </template>
          <template #cell(enterpriseName)="data">
            <span
              v-if="getFullTranslatedEnterpriseName(data.item.meta).length > 25"
              v-b-tooltip.hover
              :title="getFullTranslatedEnterpriseName(data.item.meta)"
            >
              {{ getTranslatedEnterpriseName(data.item.meta) }}
            </span>
            <span v-else>
              {{ getTranslatedEnterpriseName(data.item.meta) }}
            </span>
          </template>
          <template #cell(buildingName)="data">
            {{ getTranslatedBuildingName(data.item.meta) }}
          </template>
          <template #cell(roomName)="data">
            {{ getTranslatedRoomName(data.item.meta) }}
          </template>
          <template #cell(assignedOperator)="data">
            {{ data.item.assignedOperator || '-' }}
          </template>
          <template #cell(initiateTime)="data">
            {{ data.item.createdAt | formatDateEmpty }}
          </template>
          <template #cell(acceptedAt)="data">
            {{ data.item.acceptedAt | formatDateEmpty }}
          </template>
          <template #cell(origin)="data">
            {{ getOrigin(data.item.origin, data.item.subOrigin) }}
          </template>
          <template #cell(completedAt)="data">
            {{ data.item.completedAt | formatDateEmpty }}
          </template>
          <template #cell(serviceCategory)="data">
            {{
              data.item.serviceCategory &&
                data.item.serviceCategory.name &&
                Object.keys(data.item.serviceCategory.name).length
                ? data.item.serviceCategory.name[$i18n.locale] ||
                  data.item.serviceCategory.name['zh'] ||
                  '-'
                : '-'
            }}
          </template>
          <template #cell(serviceType)="data">
            {{
              data.item.serviceType &&
                data.item.serviceType.name &&
                Object.keys(data.item.serviceType.name).length
                ? data.item.serviceType.name[$i18n.locale] ||
                  data.item.serviceType.name['zh'] ||
                  '-'
                : '-'
            }}
          </template>
          <!-- <template #cell(serviceSubType)="data">
            {{
              data.item.serviceSubType &&
                data.item.serviceSubType.name &&
                Object.keys(data.item.serviceSubType.name).length
                ? data.item.serviceSubType.name[$i18n.locale] ||
                  data.item.serviceSubType.name['zh'] ||
                  '-'
                : '-'
            }}
          </template> -->
          <template #cell(servicePrice)="data">
            {{
              data.item.servicePrice
                ? `${formatNumber(data.item.servicePrice)} ${data.item.servicePriceCurrency}`
                : $t('field.negotiation')
            }}
          </template>
          <template #cell(orderInitiator)="data">
            <div class="name-initiator">
              <b-avatar
                :src="data.item.meta && data.item.meta.profileUrl"
                size="2rem"
                variant="primary"
              />
              <span class="ml-1">{{ getInitiatorName(data.item) }}</span>
            </div>
          </template>
          <template #cell(chatAgentName)="data">
            <p
              v-if="
                data.item.chatAgentName &&
                  Object.keys(data.item.chatAgentName).length
              "
            >
              {{
                data.item.chatAgentName[$i18n.locale] ||
                  data.item.chatAgentName['zh'] ||
                  '-'
              }}
            </p>
            <p v-else>
              {{ '-' }}
            </p>
          </template>
          <template #cell(status)="data">
            <ServiceStatus :status="data.item.status" />
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <button
                v-if="$can('manage', 'view-service')"
                class="btn-action detail"
                size="sm"
                @click="$emit('detail', data.item)"
              >
                {{ $t('button.detail') }}
              </button>
              <button
                v-if="
                  $can('manage', 'manage-modify-service') &&
                    data.item.status !== 'resolved' &&
                    data.item.status !== 'cancel' &&
                    data.item.status === 'completed'
                "
                class="btn-action detail"
                style="color: #97b834 !important"
                size="sm"
                @click="$emit('assign', data.item, 'reset', 'resetPrice')"
              >
                {{ $t('field.reset_price') }}
                <div
                  v-if="data.item.status === 'pendingDispatch'"
                  class="notification-dot"
                />
              </button>
              <button
                v-if="
                  $can('manage', 'manage-modify-service') &&
                    data.item.status !== 'resolved' &&
                    data.item.status !== 'cancel' &&
                    (data.item.status === 'pending' ||
                      (data.item.status === 'pendingPrice' &&
                        data.item.assignedOperatorId))
                "
                class="btn-action detail"
                style="color: #97b834 !important"
                size="sm"
                @click="
                  $emit(
                    'assign',
                    data.item,
                    data.item.status === 'pending' ? 'restart' : 'reset',
                    data.item.status === 'pending' ? 'reassignOperator' : 'reassignPriceSpecialist'
                  )
                "
              >
                {{ $t('button.reassign') }}
                <div
                  v-if="data.item.status === 'pendingDispatch'"
                  class="notification-dot"
                />
              </button>
              <button
                v-if="
                  $can('manage', 'manage-modify-service') &&
                    data.item.status !== 'resolved' &&
                    data.item.status !== 'cancel' &&
                    (data.item.status === 'pendingDispatch' ||
                      (data.item.status === 'pendingPrice' &&
                        !data.item.assignedOperatorId))
                "
                class="btn-action detail"
                style="color: #97b834 !important"
                size="sm"
                @click="
                  $emit(
                    'assign',
                    data.item,
                    data.item.status === 'pendingDispatch' ? 'restart' : 'reset',
                    data.item.status === 'pendingDispatch' ? 'assignOperator' : 'assignPriceSpecialist'
                  )
                "
              >
                {{ $t('button.assign') }}
                <div
                  v-if="data.item.status === 'pendingDispatch'"
                  class="notification-dot"
                />
              </button>
              <button
                v-if="
                  $can('manage', 'manage-modify-service') &&
                    data.item.status !== 'resolved' &&
                    data.item.status !== 'cancel' &&
                    (data.item.status === 'accepted' ||
                      data.item.status === 'processing' ||
                      data.item.status === 'completed' ||
                      data.item.status === 'hold' ||
                      data.item.status === 'pendingPrice')
                "
                class="btn-action detail"
                style="color: #50b839 !important"
                size="sm"
                @click="$emit('assign', data.item, 'restart', 'restartService')"
              >
                {{ $t('field.restart_service') }}
                <div
                  v-if="data.item.status === 'pendingDispatch'"
                  class="notification-dot"
                />
              </button>
              <button
                v-if="
                  $can('manage', 'manage-service-price') &&
                    data.item.status === 'pendingPrice' &&
                    (!data.item.assignedOperatorId ||
                      (data.item.assignedOperatorId &&
                        data.item.assignedOperatorId === userData.id)) && 
                        data.item.allowResetPrice
                "
                class="btn-action detail"
                style="color: rgb(0, 123, 255) !important"
                size="sm"
                @click="$emit('price', data.item)"
              >
                {{ $t('field.price') }}
                <div class="notification-dot" />
              </button>
              <button
                v-if="
                  $can('manage', 'manage-service-operation') &&
                    data.item.status !== 'resolved' &&
                    data.item.status !== 'cancel'
                "
                class="btn-action detail"
                style="color: #c0392b !important"
                size="sm"
                @click="$emit('cancel', data.item)"
              >
                {{ $t('button.cancel') }}
              </button>
              <button
                v-if="
                  $can('manage', 'manage-modify-service') &&
                    data.item.status !== 'resolved' &&
                    data.item.status !== 'cancel' && (
                      data.item.status === 'pending'
                      || data.item.status === 'accepted'
                      || data.item.status === 'processing')
                "
                size="sm"
                class="btn-action detail"
                variant="outline-danger"
                @click="$emit('addOther', data.item)"
              >
                {{ $t('button.add_others') }}
              </button>
              <button
                v-if="data.item.origin === 'external'"
                size="sm"
                class="btn-action detail"
                variant="outline-danger"
                @click="$emit('goToChat', data.item)"
              >
                {{ $t('button.chat') }}
              </button>
            </div>
          </template>
        </n-table>
        <n-pagination
          :key="query.page"
          class="mt-2"
          :total="total"
          :per-page="10"
          :page="query.page"
          @change="list"
        />
      </div>
    </div>

   

    <!-- <CreateServiceOrderModal
      v-model="isCreateServiceOrderModalVisible"
      @hide="isCreateServiceOrderModalVisible = false"
      @service-selected="isMaintenanceServiceModalVisible = true"
    />

    <MaintenanceServiceModal
      v-model="isMaintenanceServiceModalVisible"
      @hide="isMaintenanceServiceModalVisible = false"
    /> -->
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import NPagination from '@/components/NPagination.vue'
import NTable from '@/components/NTable.vue'
import { avatarText } from '@core/utils/filter'
import Repository from '@/repositories/RepositoryFactory'
import moment from 'moment-timezone'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect.vue'
import NDatePicker from '@/components/NDatePicker.vue'
import NSingleSelect from '@/components/NSingleSelect.vue'
import store from '@/store'
import useAppStore from '@/store-pinia/useAppStore'
import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import { formatNumber } from '@/@core/utils/utils'
import TableFields from './tableFields'
import SearchInputs from './searchInput'
import ServiceStatus from './components/ServiceStatus.vue'
// import CreateServiceOrderModal from '@/components/service/CreateServiceOrderModal.vue'
// import MaintenanceServiceModal from '@/components/service/MaintenanceServiceModal.vue'
import ServiceSystemFormService from '@/components/global-components/ServiceSystemFormService.vue'

const ServiceSystemRepository = Repository.get('serviceSystem')
// const TeamPerformanceRepository = Repository.get(
//   'employeePerformanceOverview',
// )

export default {
  components: {
    BAvatar,
    BButton,
    BFormGroup,
    BFormInput,
    NSingleSelect,
    NPagination,
    NTable,
    NAsyncSingleSelect,
    NDatePicker,
    ServiceStatus,
    // CreateServiceOrderModal,
    // MaintenanceServiceModal,
    ServiceSystemFormService
  },
  props: {
    channels: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      perPageOptions: [10],
      params: {
        operator: this.$route.query.operator || undefined,
        startDate: this.$route.query.startDate || undefined,
        endDate: this.$route.query.endDate || undefined,
        search: this.$route.query.search || undefined,
        serviceType: this.$route.query.serviceType || undefined,
        serviceSubType: this.$route.query.serviceSubType || undefined,
        projectId: this.$route.query.projectId || undefined,
        origin: this.$route.query.origin || undefined,
        departmentId: this.$route.query.departmentId || undefined,
        serviceCategory: this.$route.query.serviceCategory || undefined,
        status: this.$route.query.status || undefined,
        ...store.state.app.serviceSystemQuery,
      },
      query: {
        page: Number(this.$route.query.page) || 1,
        order: this.$route.query.order || null,
        sort: this.$route.query.sort || null,
        search: this.$route.query.search || '',
        operator: this.$route.query.operator || null,
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
        serviceType: this.$route.query.serviceType || null,
        serviceSubType: this.$route.query.serviceSubType || null,
        projectId: this.$route.query.projectId || null,
        origin: this.$route.query.origin || null,
        departmentId: this.$route.query.departmentId || null,
        status: this.$route.query.status || null,
        serviceCategory: this.$route.query.serviceCategory || null,
        ...store.state.app.serviceSystemQuery,
      },
      moment,
      avatarText,
      tabs: [
        { text: 'chat.all', value: '' },
        { value: 'pending', text: 'status.pending' },
        { value: 'accepted', text: 'status.accepted' },
        { value: 'processing', text: 'status.processing' },
        { value: 'pendingPrice', text: 'status.pendingPrice' },
        { value: 'completed', text: 'status.completed' },
        { value: 'resolved', text: 'status.closed' },
        { value: 'cancel', text: 'status.cancel' },
        { value: 'hold', text: 'status.hold' },
        { value: 'pendingDispatch', text: 'status.pendingDispatch' },
      ],
      isCollapsed: true,
      activeTab: '',
      indicatorPosition: '4px',
      indicatorWidth: '100%',
      serviceCategories: null,
      loadingTabs: false,
      // isCreateServiceOrderModalVisible: false,
      // isMaintenanceServiceModalVisible: false,
    }
  },
  computed: {
    badgeCount() {
      if (!this.activeTab) return this.appStore.serviceBadgeCount
      return (
        this.appStore.serviceBadgeCount[this.activeTab] || {
          all: 0,
          pendingPrice: 0,
          pendingDispatch: 0,
        }
      )
    },
    currentLocale() {
      let { locale } = this.$i18n
      if (locale === 'zh-cn') {
        locale = 'zh'
      }
      return locale
    },
    mainTabs() {
      const allServices = this.appStore.serviceCategories || []

      if (allServices.length === 0) return []

      // If user has ALL_CATEGORY access or is Super Admin, show all services
      if (this.appStore.allowedServiceCategories.includes('ALL_CATEGORY')) {
        return [
          {
            text: this.$t('chat.all'),
            value: '',
          },
          ...allServices.map(service => ({
            text:
                service.name[this.currentLocale]
                || service.name?.en
                || service.name?.zh
                || service.name?.km
                || service.name?.vi,
            value: service.code,
          })),
        ]
      }

      // Otherwise filter based on user's assigned categories
      const availableCategories = this.appStore.allowedServiceCategories.map(
        cat => ({
          text:
              allServices.find(service => service.code === cat)?.name?.[
                this.currentLocale
              ]
              || cat.name?.en
              || cat.name?.zh
              || cat.name?.km
              || cat.name?.vi,
          value: cat,
        }),
      )

      return availableCategories.length > 1
        ? [{ text: this.$t('chat.all'), value: '' }, ...availableCategories]
        : availableCategories
    },
    userData() {
      return this.$store.state.profile?.email
          || this.$store.state.profile?.phone
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
    departments() {
      return this.userData?.departments || []
    },
    isSuperAdmin() {
      return this.userData?.roleNames?.includes('Super Admin')
    },
    perPage: {
      get() {
        return 10
      },
      set(value) {
        this.$store.commit('pagination/SET_PER_PAGE', value)
      },
      currentLocale() {
        return this.$i18n.locale
      },
    },
  },
  watch: {
    mainTabs: {
      handler(newTabs) {
        // Handle tab changes in real-time
        this.$nextTick(() => {
          if (newTabs.length === 1) {
            this.activeTab = newTabs[0].value
            this.indicatorPosition = '4px'
            this.indicatorWidth = 'calc(100% - 8px)'
          } else if (newTabs.length > 1) {
            const idx = newTabs.findIndex(
              tab => tab.value === this.$route.query.serviceCategory,
            )
            if (idx > -1) {
              this.activeTab = this.$route.query.serviceCategory
              const tabCount = newTabs.length
              const percentPerTab = 100 / tabCount
              this.indicatorPosition = `calc(${idx * percentPerTab}% + 4px)`
              this.indicatorWidth = `calc(${percentPerTab}% - 8px)`
            } else {
              // Default to first tab if not found
              this.activeTab = newTabs[0].value
              this.indicatorPosition = '4px'
              const tabCount = newTabs.length
              this.indicatorWidth = `calc(${100 / tabCount}% - 8px)`
            }
          }

          if (!this.activeTab) {
            this.activeTab = ''
          }
        })
      },
      immediate: true,
    },
    perPage() {
      this.list()
    },
    '$route.query.serviceCategory': {
      handler(value) {
        this.$nextTick(() => {
          const idx = this.mainTabs.findIndex(tab => tab.value === value)
          if (idx > -1) {
            this.activeTab = value
            const tabCount = this.mainTabs.length
            const percentPerTab = 100 / tabCount
            this.indicatorPosition = `calc(${idx * percentPerTab}% + 4px)`
            this.indicatorWidth = `calc(${percentPerTab}% - 8px)`
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    this.appStore.setServiceContentVisible(false)
  },
  created() {
    this.a = document.createElement('a')
    document.body.appendChild(this.a)
    this.a.style = 'display: none'
  },
  methods: {
    getInitiatorName(data) {
      const name = data?.meta?.name || data?.customer?.name
      if (typeof name === 'object') {
        return name?.[this.currentLocale] || name?.en || name?.zh || name?.km || name?.vi || '-'
      }
      return name || '-'
    },
    getTranslatedEnterpriseName(meta) {
      const name = meta?.translation?.enterpriseName?.[this.currentLocale] || meta?.translation?.enterpriseName?.en || meta?.translation?.enterpriseName?.zh || meta?.translation?.enterpriseName?.km || meta?.translation?.enterpriseName?.vi || meta?.enterpriseName || '-'
      return name.length > 25 ? name.substring(0, 25) + '...' : name
    },
    getFullTranslatedEnterpriseName(meta) {
      return meta?.translation?.enterpriseName?.[this.currentLocale] || meta?.translation?.enterpriseName?.en || meta?.translation?.enterpriseName?.zh || meta?.translation?.enterpriseName?.km || meta?.translation?.enterpriseName?.vi || meta?.enterpriseName || '-'
    },
    getTranslatedBuildingName(meta) {
      return meta?.translation?.buildingName?.[this.currentLocale] || meta?.translation?.buildingName?.en || meta?.translation?.buildingName?.zh || meta?.translation?.buildingName?.km || meta?.translation?.buildingName?.vi || meta?.buildingName || '-'
    },
    getTranslatedRoomName(meta) {
      return meta?.translation?.roomName?.[this.currentLocale] || meta?.translation?.roomName?.en || meta?.translation?.roomName?.zh || meta?.translation?.roomName?.km || meta?.translation?.roomName?.vi || meta?.roomName || '-'
    },
    getSubType(data) {
      return data?.serviceSubTypes?.map(subType => subType.name?.[this.currentLocale] || subType.name?.en || subType.name?.zh || subType.name?.km || subType.name?.vi).filter(Boolean)
    },
    getOrderId(data) {
      return data?.finalResultParams?.orderId || data?.id || '-'
    },
    copyToClipboard(orderId) {
      this.$copyText(orderId).then(
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('general.copied'),
              icon: 'CopyIcon',
            },
          })
        },
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('general.cannotCopy'),
              icon: 'AlertCircleIcon',
            },
          })
        },
      )
    },
    getProjectName(projectName) { 
      if (typeof projectName === 'object') {
        return projectName?.[this.currentLocale] || projectName?.en || projectName?.zh || projectName?.km || projectName?.vi || '-'
      }
      return projectName || '-'
    },
    getServiceName(name, shortenName) {
      if (name) {
        return (
            name?.[this.currentLocale]
            || name?.en
            || name?.zh
            || name?.km
            || name?.vi
            || '-'
        )
      }
      return shortenName
    },
    getServiceCategoryBadgeCount(tab) {
      return tab
        ? this.appStore.serviceBadgeCount?.[tab]?.all
        : this.appStore.serviceBadgeCount?.all
    },
    getOrigin(origin, subOrigin) {
      const validOrigin = ['external', 'manual', 'chatagent']

      if (validOrigin.includes(origin)) {
        if (subOrigin) {
          return this.$t(`general.${subOrigin}`)
        }
        return this.$t(`general.${origin}`)
      }

      return '-'
    },
    setActiveTab(tab, index) {
      if (this.loading) return
      this.activeTab = tab
      const tabCount = this.mainTabs.length
      const percentPerTab = 100 / tabCount
      this.indicatorPosition = `calc(${index * percentPerTab}% + 4px)`
      this.indicatorWidth = `calc(${percentPerTab}% - 8px)`

      this.query.serviceCategory = tab
      this.params.serviceCategory = tab
      this.query.page = 1
      this.params.page = 1
      this.updateQuerySting()
      this.getData()
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
    onChange() {
      this.$emit('input', this.data)
    },
    onTabClick(tab) {
      if (this.loading) return
      this.query.status = tab
      this.params.status = tab
      this.query.page = 1
      this.params.page = 1

      this.updateQuerySting()
      this.getData()
    },
    toMinutesSeconds(totalSeconds) {
      const seconds = Math.floor(totalSeconds % 60)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600)
      const secondsStr = this.makeHumanReadable(seconds, 'second')
      const minutesStr = this.makeHumanReadable(minutes, 'minute')
      const hoursStr = this.makeHumanReadable(hours, 'hour')
      const string = `${hoursStr}${minutesStr}${secondsStr}`.replace(
        /,\s*$/,
        '',
      )

      return string || `0 ${this.$tc('time.second', 0)}`
    },
    makeHumanReadable(num, singular) {
      return num > 0 ? `${num} ${this.$tc(`time.${singular}`, num)} ` : ''
    },
    calculateDate() {
      // let dates
      // if (this.params.period === 'other') {
      //   dates = calculateDatesByPeriod('thisWeek')
      // } else {
      //   dates = calculateDatesByPeriod(this.params.period)
      // }
      // if (dates.length) {
      //   [this.params.startDate, this.params.endDate] = dates
      // }
    },
    updateQuerySting() {
      this.$router.replace({ query: this.query })
      store.commit('app/UPDATE_SERVICE_SYSTEM_QUERY', { ...this.query })
    },
    list(page = 1) {
      if (this.loading) return
      this.query.page = page
      this.params.page = page
      this.updateQuerySting()
      this.getData()
    },
    sortChanged(sortBy, sortDirection) {
      if (this.loading) return
      this.query.order = sortBy
      this.query.sort = sortDirection
      this.updateQuerySting()
      this.getData()
    },
    search() {
      if (this.loading) return
      this.query = {
        ...this.query,
        ...this.params,
      }
      this.updateQuerySting()
      this.getData()
    },
    reset() {
      if (this.loading) return
      this.params.search = ''
      this.params.serviceType = null
      this.params.serviceSubType = null
      this.params.project = null
      this.params.origin = null
      this.params.department = null
      this.params.startDate = null
      this.params.endDate = null
      this.params.operator = null
      this.params.projectId = null
      this.params.departmentId = null
      this.params.page = 1
      this.query = {
        ...this.query,
        ...this.params,
      }
      this.updateQuerySting()
      this.getData()
    },
    getData() {
      if (this.loading) return
      if (!this.params.startDate || !this.params.endDate) {
        this.calculateDate()
        this.query = {
          ...this.query,
          ...this.params,
        }
      }
      this.$emit('filter', this.query)
    },
    exportExcel() {
      // this.loading = true
      ServiceSystemRepository.exportExcel({
        ...this.query,
        lang: this.$i18n.locale.split('-')[0] === 'zh' ? 'zh' : 'en',
      })
        .then(response => {
          const utf8WithBom = `\uFEFF${response.data}` // Add BOM for UTF-8
          const blob = new Blob([utf8WithBom], {
            type: 'text/csv;charset=utf-8;',
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url

          const fileName = `${this.$t(
            'general.service_report',
          )}-${moment().format('DD-MMM-YYYY')}.csv`

          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          // Clean up
          URL.revokeObjectURL(url)
        })
        .catch(error => {
          // this.loading = false
          console.log('error', error)
        })
        .then(() => {
          // this.loading = false
        })
    },
  },
  setup() {
    const fields = TableFields
    const searchFields = SearchInputs
    const permissionType = 'view-service'
    const appStore = useAppStore()
    return {
      fields,
      searchFields,
      permissionType,
      appStore,
      formatNumber,
    }
  },
}
</script>

<style lang="scss">
  // Animation classes
  .expand-enter-active,
  .expand-leave-active {
    transition: all 0.3s ease-out;
    max-height: 300px; // Adjust this value based on your content height
    overflow: hidden;
    opacity: 1;
    transform: translateY(0);
  }

  .expand-enter,
  .expand-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-20px);
  }

  .b-card {
    background-color: white;
    box-shadow: none;
    border: 1px solid var(--light);
    border-radius: 0.5rem;
  }

  .icon-collapse {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 1rem;

    svg {
      width: fit-content;
      height: fit-content;
      cursor: pointer;
    }
  }

  .badge-indicator {
    background: #c0392b;
    color: white;
    flex-shrink: 0;
    border-radius: 10rem;
    min-width: 20px;
    height: 20px;
    display: flex;
    font-size: 11px;
    justify-self: center;
    align-self: center;
    align-items: center;
    justify-content: center;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    padding: 0.3rem 0.5rem;
  }

  .filter-container {
    display: grid;
    padding: 1.5rem 0 0 0;
    background: white;
    gap: 1rem;
    grid-template-columns: repeat(4, 1fr);

    .form-group {
      transition: all 0.3s ease;

      &.has-value {
        .form-control,
        .vs__dropdown-toggle {
          border-color: var(--primary);
        }
      }
    }

    // Special handling for date pickers
    .n-date-picker {
      &.has-value {
        .mx-input {
          border-color: var(--primary) !important;
        }
      }

      .mx-input {
        transition: border-color 0.3s ease;
      }
    }

    .datetime-picker {
      display: flex;
      gap: 0.5rem;
    }

    .btn-container {
      padding-top: 1.925rem;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
      height: fit-content;
      align-items: flex-end;

      .btn-reset,
      .btn-export {
        background-color: #f2eff6 !important;
        color: var(--primary) !important;
        border-color: #f2eff6 !important;
      }

      button {
        flex: 1;
        white-space: nowrap;
      }
    }

    label {
      font-weight: 500 !important;
    }
  }

  .action-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 0.75rem;

    .btn-handover {
      cursor: pointer;
      color: var(--primary);
      font-weight: 500;
    }

    .tab-list {
      display: flex;
      gap: 0.75rem;
      padding: 1.75rem 0;
      font-weight: 500;

      div {
        cursor: pointer;
      }

      .selected {
        color: var(--primary);
        border-bottom: 2px solid var(--primary);
      }
    }
  }

  /* Container */
  .switch-container {
    display: flex;
    justify-content: flex-start;
    padding: 1rem 0 1.5rem 0;
    justify-content: space-between;
  }

  /* Background */
  .switch-background {
    position: relative;
    display: flex;
    justify-content: space-around;
    // Width based on number of tabs: 210px per tab with minimum size
    &[data-tabs='0'],
    &[data-tabs='1'] {
      width: 210px;
    }
    &[data-tabs='2'] {
      width: 420px;
    }
    &[data-tabs='3'] {
      width: 630px;
    }
    &[data-tabs='4'] {
      width: 840px;
    }
    &[data-tabs='5'] {
      width: 1050px;
    }
    &[data-tabs='6'] {
      width: 1260px;
    }
    &[data-tabs='7'] {
      width: 1470px;
    }
    background: #f7f7f7;
    border-radius: 0.5rem;
    padding: 4px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  /* Indicator (animated background) */
  .switch-indicator {
    position: absolute;
    top: 4px;
    bottom: 4px;
    width: v-bind(indicatorWidth);
    background: var(--primary);
    color: white;
    border-radius: 0.5rem;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    will-change: transform, width, left;
    transform: translateZ(0);
  }

  /* Buttons */
  .switch-button {
    flex: 1;
    display: flex;
    gap: 0.25rem;
    justify-content: center;
    align-items: center;
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    border: none;
    background: transparent;
    cursor: pointer;
    color: #6b6873;
    transition: color 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    position: relative;
    z-index: 8;
    white-space: nowrap;
    min-width: 100px;
  }

  .switch-button.active {
    color: white;
  }

  .btn-action {
    background: none !important;
    border: none !important;
    font-weight: 500;
    font-size: 12px;

    &:hover:not(.back-icon) {
      background-color: #f8f9fa !important;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      border-radius: 0.25rem;
    }

    &.btn-primary:active,
    &.btn-primary:focus {
      background: transparent !important;
    }

    &.detail {
      color: #6b6873 !important;
    }

    &.cancel {
      color: #ff4141 !important;
    }

    &.assign-to-other {
      color: #48b35e !important;
    }
  }

  .name-initiator {
    display: flex;
    align-items: center;

    img,
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f7f7f7;
      width: 21px;
      height: 21px;
      border-radius: 50%;
    }
  }

  .custom-service-table {
    table {
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
    }

    .table thead th {
      background: transparent !important;
      color: var(--primary) !important;
      text-transform: capitalize;
      font-weight: 600;
      font-size: 1rem;
      padding: 1.5rem 0.75rem;
      // border-right: none !important;
    }

    .table td {
      border-top: none !important;
    }
  }

  .switch-button--placeholder {
    opacity: 0.5;
    pointer-events: none;
  }

  .switch-background--loading {
    background: #f7f7f7;
    min-width: 190px;
  }

  .switch-button--loading {
    height: 32px;
    background: linear-gradient(90deg, #f0f0f0 25%, #f7f7f7 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 0.5rem;
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .sticky-service-status {
    right: 310px;
  }

  .sticky-service-actions {
    right: 0;
  }

  .sticky-service-status,
  .sticky-header {
    border-left: 1px solid var(--light);
    border-right: 1px solid var(--light);
  }

  .sticky-header-actions {
    border-left: none !important;
    border-right: none !important;
  }

  /* Notification dot styling */
  .notification-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #c0392b;
    margin-left: 5px;
    position: relative;
    box-shadow: 0 0 0 rgba(255, 65, 65, 0.4);
    animation: pulse 2s infinite;
  }

  /* Badge count styling */
  .badge-count {
    background: #c0392b;
    color: white;
    border-radius: 12px;
    min-width: 20px;
    height: 20px;
    display: flex;
    font-size: 11px;
    font-weight: 500;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    box-shadow: 0 2px 4px rgba(255, 65, 65, 0.3);
    margin-left: 2px;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 65, 65, 0.4);
    }
    70% {
      box-shadow: 0 0 0 6px rgba(255, 65, 65, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 65, 65, 0);
    }
  }

  .hidden {
    visibility: hidden;
  }
</style>

<style>
  /* Global styles for date picker */
  .custom-date-picker .date-picker .mx-input {
    transition: border-color 0.3s ease !important;
    border-color: var(--input-border-color, #ccc) !important;
  }

  /* Direct targeting of the mx-input inside custom-date-picker */
  .custom-date-picker .mx-input {
    transition: border-color 0.3s ease !important;
    border-color: var(--input-border-color, #ccc) !important;
  }

  /* Most specific selector targeting the actual input */
  .datetime-picker
    .custom-date-picker
    .date-picker
    .mx-input-wrapper
    .mx-input {
    border-color: var(--input-border-color, #ccc) !important;
  }
  /* Target the input directly */
  .datetime-picker .custom-date-picker input.mx-input {
    border-color: var(--input-border-color, #ccc) !important;
  }

  .disabled-btn {
    cursor: not-allowed !important;
  }
</style>
